import { ReactElement } from 'react';

import DialogImportOrdersFromCSV from '../../DialogImportOrdersFromCSV';
import DialogImportOrdersFromIntegration from '../../DialogImportOrdersFromIntegration';
import DialogImportFromAssociatedCompany from '../../DialogImportFromAssociatedCompany';

import { AddOrdersActionsImportDialogsProps } from './types';

const AddOrdersActionsImportDialogs = ({
  dialogImportFromFile,
  dialogImportFromIntegration,
  dialogImportFromAssociatedCompany,
  onSubmitImportSuccess,
}: AddOrdersActionsImportDialogsProps): ReactElement => (
  <>
    <DialogImportOrdersFromCSV
      {...dialogImportFromFile}
      onSubmitSuccess={onSubmitImportSuccess}
    />

    <DialogImportOrdersFromIntegration
      {...dialogImportFromIntegration}
      onSubmitSuccess={onSubmitImportSuccess}
    />

    <DialogImportFromAssociatedCompany
      {...dialogImportFromAssociatedCompany}
      onSubmitSuccess={onSubmitImportSuccess}
    />
  </>
);

export default AddOrdersActionsImportDialogs;
